import { useCallback } from 'react'
import { useWeb3React } from '@web3-react/core'

import { useAppDispatch } from 'state'
import { useGetConnection } from 'web3/connection'
import { updateSelectedWallet } from 'state/wallet/reducer'

import SelectNetwork from 'components/SelectNetwork'
import { useWalletModal } from 'components/WalletModal'

const ConnectButton = () => {
  const { openWalletModal } = useWalletModal()
  const { account, connector } = useWeb3React()
  const dispatch = useAppDispatch()

  const getConnection = useGetConnection()

  const connection = getConnection(connector)

  const connected = !!account

  const disconnect = useCallback(() => {
    if (connector && connector.deactivate) {
      connector.deactivate()
    }

    connector.resetState()
    dispatch(updateSelectedWallet(undefined))
  }, [connector, dispatch])

  if (connected) {
    return (
      <ul className="flex-2 flex justify-end items-center">
        <li>
          <SelectNetwork />
        </li>
        <li className="ml-6">
          <button className="flex gap-2 pointer-events-auto rounded-md bg-purple-900 px-3 py-2 text-[0.8125rem] font-semibold leading-5 text-white hover:bg-indigo-500" onClick={disconnect}>
            <div className='text-ellipsis overflow-hidden max-w-32' title={account}>
              {account}
            </div>
            <img width="20px" height="20px" src={connection.getIcon()} alt={connection.getName()} />
          </button>
        </li>
      </ul>
    )
  }

  return (
    <button className="flex gap-2 pointer-events-auto rounded-md bg-purple-900 px-3 py-2 text-[0.8125rem] font-semibold leading-5 text-white hover:bg-indigo-500" onClick={openWalletModal}>
      Connect Wallet
    </button>
  )
}

export default ConnectButton
